import { action } from 'satcheljs';
import { LinkNavigationParameters } from 'owa-app-host-services/lib/services/DeepLinkService';

type OpenMosAppAction = Omit<LinkNavigationParameters, 'appId'> & {
    subEntityLabel?: string;
};

export const onOpenMOSAppWithContext = action(
    'onOpenMOSAppWithContext',
    ({ appDefinition, entityId, subEntityId, subEntityLabel }: OpenMosAppAction) => ({
        appDefinition,
        entityId,
        subEntityId,
        subEntityLabel,
    })
);
